import { render, staticRenderFns } from "./IcWatchLater.vue?vue&type=template&id=bdcbf836&scoped=true"
import script from "./IcWatchLater.vue?vue&type=script&lang=js"
export * from "./IcWatchLater.vue?vue&type=script&lang=js"
import style0 from "./IcWatchLater.vue?vue&type=style&index=0&id=bdcbf836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcbf836",
  null
  
)

export default component.exports